import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=6fb56d2e&scoped=true"
import script from "./LoadingPage.vue?vue&type=script&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&lang=ts"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=6fb56d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb56d2e",
  null
  
)

export default component.exports